import { create } from "zustand";
import { endOfWeek, format, startOfWeek } from "date-fns";

import { CalendarData } from "@/features/calendar/types/calendar.ts";

export type DateRange = {
  from: string;
  to: string;
};

type CalendarStore = {
  calendarData: CalendarData | null;
  shownDays: 1 | 3 | 7;
  setCalendarData: (data: CalendarData | null) => void;
  setShownDays: (days: 1 | 3 | 7) => void;
  dateRange: DateRange;
  setDateRange: (dateRange: DateRange) => void;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  toReload: boolean;
  setToReload: (toReload: boolean) => void;
};

export const useCalendarStore = create<CalendarStore>((set) => ({
  calendarData: null,
  toReload: false,
  setToReload: (toReload: boolean) => set({ toReload }),
  shownDays: 7,
  setCalendarData: (data) => set({ calendarData: data }),
  setShownDays: (days) => set({ shownDays: days }),
  setDateRange: (dateRange) => set({ dateRange }),
  dateRange: {
    from: format(startOfWeek(new Date(), { weekStartsOn: 1 }), "yyyy-MM-dd"),
    to: format(endOfWeek(new Date(), { weekStartsOn: 1 }), "yyyy-MM-dd"),
  },
  isLoading: true,
  setIsLoading: (isLoading) => set({ isLoading }),
}));
